module.exports = __webpack_public_path__ + "img/ROCQTR_COUL.0002d36b.jpg";